import { ACTION_TYPES, STATUS_TYPES, Story } from '@shared/api/types/story';

export const magicSquareLearnToEarn: Story = {
  id: 'magic-square-learn-to-earn',
  type: 'SOQUEST',
  status: STATUS_TYPES.ACTIVE,
  name: 'Magic Square Learn To Earn',
  index: 0,
  content: {
    type: ACTION_TYPES.SOQUEST,
    config: {
      key: 'd75e8106fea025a2177a42788660b8f32eec',
      scode: 'MagicSquare',
      ccode: 'bNykOqTi34',
    },
  },
};
